// extracted by mini-css-extract-plugin
export default {"hero":"style_hero__JMmF6","hero__card":"style_hero__card__uNtRh"};